import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useVhAdminAccess } from '@/admin/useVhAdminAccess';
import { useAuth } from '@/store/auth/auth.store';

export const AdminGuard = ({ children }: { children: ReactNode }) => {
  const { isLoggedIn, isInitializing } = useAuth();
  const status = useVhAdminAccess();

  if (isInitializing) return null;
  if (!isLoggedIn) return <Navigate to="/auth" replace />;
  if (status === 'idle' || status === 'checking') return null;
  if (status === 'denied') return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
};
